export default "__VITE_ASSET__816fe372__"